package com.downdogapp.client

actual fun createMediaPlayer(video: Boolean,
                             loop: Boolean): MediaPlayer =
  JsMediaPlayer(video, loop)

actual fun createBackgroundMediaPlayer(
  video: Boolean,
  loop: Boolean,
  callback: (MediaPlayer) -> Unit
) =
  callback(
    createMediaPlayer(
      video = video,
      loop = loop
    )
  )
